import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from 'react';

import {
  Modal,
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Chip,
  Switch, Tooltip,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ShareIcon from "@mui/icons-material/Share";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ArrowBack, ArrowForward, ZoomIn } from '@mui/icons-material';
import Lightbox from 'yet-another-react-lightbox';
import {useTranslation} from "react-i18next";

import 'yet-another-react-lightbox/styles.css';

import Video from "yet-another-react-lightbox/plugins/video";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
// eslint-disable-next-line import/no-extraneous-dependencies
import ReactPlayer from "react-player";
import {enqueueSnackbar} from "notistack";
import ListItem from "@mui/material/ListItem";
import DownloadIcon from "@mui/icons-material/Download";
import List from "@mui/material/List";
import Popover from "@mui/material/Popover";
import MenuItem from "@mui/material/MenuItem";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import EditIcon from "@mui/icons-material/Edit";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Paper from "@mui/material/Paper";
import {useBoolean} from "../hooks/use-boolean";
import axios from "../utils/axios";
import Image from "../components/image";
import {useAxStore} from "../store/axStore";
 import PdfViewerModal from "./pixPdfViewModal";
import {useLocales} from "../locales";
import ImageWithAnnotations from "../components/pixme/ImageWithAnnotations";

const ModalLightboxForFilePreview = ({ slides, curindex, setIndex }) => {

  const showDetailedInfo=false; // turn this on/off while developing detailedinfo


  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(curindex);
  const [lightboxIndex, setLightboxIndex] = useState(curindex);
  const [currentImageId, setCurrentImageId] = useState(curindex);
  const [detailedInfo, setDetailedInfo] = useState(null);
  const [currentFileVideoUrl, setCurrentFileVideoUrl] = useState(null);

  const [openPdfViewer, setOpenPdfViewer] = useState(false);

  const { t, onChangeLang } = useTranslation()
  const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'flv', 'wmv', 'm4v'];
  const isVideo = (filename) => {
    if (!filename) return false; // Ak je undefined alebo null, vráti false
    const ext = filename.split('.').pop().toLowerCase();
    return videoExtensions.includes(ext);
  };

  const {
    selectedFiles_exists,
    selectedFiles_insert,
    selectedFiles_delete,
    axCurrentDepartment,
  } = useAxStore();
  // const axStore=useAxStore()
  const locales = useLocales();
    const showInLocaleLanguage=axCurrentDepartment.lang_iso_code===locales.currentLang.value;

  const [fileInfo, setFileInfo] = useState({
    caption: "Sunset over the lake",
    originalFileName: "IMG_12345.jpg",
    resolution: "1920x1080",
    dateTaken: "2023-06-15",
    dateUploaded: "2025-03-20",
    author: "John Doe",
    checked: true,
    license: "Creative Commons Attribution 4.0",
    systemAlert: "No issues detected",
    userInfo: "Updated by Alice Smith",
    licenseValidity: "2026-06-15",
    description: "A beautiful photo of a sunset taken during summer vacation.",
    storageInfo: [
      { resolution: "1920x1080", size: "2 MB" },
      { resolution: "1280x720", size: "1.2 MB" },
      { resolution: "640x480", size: "600 KB" },
    ],
    exifInfo: "Camera: Canon EOS 80D, Aperture: f/8.0, Shutter: 1/125s, ISO: 100",
    userTags: ["vacation", "sunset", "nature"],
    aiTagsEnglish: ["sunset", "lake", "clouds", "summer"],
    aiTagsLocal: ["západ slnka", "jazero", "oblaky", "leto"],
    directories: ["/Vacation/2023", "/Favorites"],
    downloadLog: [
      "Downloaded by Alice Smith on 2025-03-19",
      "Downloaded by Bob Johnson on 2025-03-18",
    ],
    processingLog: "Processed for resizing and color correction on 2025-03-20",
  });

  const handleSelect = useCallback(() => {
    if (selectedFiles_exists(currentImageId)) {
      selectedFiles_delete(currentImageId);
    } else {
      selectedFiles_insert(currentImageId);
    }
  }, [currentImageId, selectedFiles_exists, selectedFiles_insert, selectedFiles_delete]);

  // Event handler na počúvanie medzerníka
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.code === "Space") {
        event.preventDefault(); // Zabraňuje posunutiu stránky
        handleSelect();
      }
    };

    if (curindex >= 0) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [curindex, handleSelect]);
  const gettingDetailedFileInfo=useBoolean(false);
  const fetchFileInfo = (index) => {
    const slide = slides[index];
    const imageId = slide ? slide.id : undefined;

    gettingDetailedFileInfo.onTrue()
    if(imageId>0&&!gettingDetailedFileInfo.value){
      let headers={}
      const jwt = localStorage.getItem('axjwt');
      if(jwt) {
        headers = {
          'Authorization': `Bearer ${jwt}`
        }
        const params = {
          'action': 'get_detailed_file_info',
          'aiDetection': isDetectionsVisible,
          'fid': imageId
        }
        axios.get('https://api.administrix.pro/v1/get/', {
          headers,
          params
        })
          .then((response => {
            if (response.data.data) {
              const {data} = response.data;
              const {meta} = response.data;

              if (meta.jwt) localStorage.setItem('axjwt', meta.jwt);else{
              localStorage.removeItem('axjwt');

              window.location.href = '/auth/jwt/login?returnTo=%2Fdashboard';
            }

              if(data.file_detail) {
                    setDetailedInfo(data.file_detail)
                // setTags(data.file_detail.tags)
              }
              // console.log("got detailed file info:", data);

            }else if (response.data.error){
              const {error} = response.data;
              enqueueSnackbar(`Chyba pri načítavaní dát o súbore: ${error.title}`,{ variant: `error`,autoHideDuration: 6000 });
            }
          }))
          .catch(error => {
            console.log("any get_detailed_file_info fetch api error");
            console.log(error);
          })
      }
    }
    gettingDetailedFileInfo.onFalse()

    // ************
     // console.log(`Fetching details for image ID: ${imageId}`);
    setCurrentImageId(imageId)
    /* const fetchedInfo = {
      title: `Názov obrázka ${imageId}`,
      description: `Popis obrázka ${imageId}`,
      date: "12.12.2023",
      properties: Array.from({ length: 5 }, (_, idx) => ({
        key: `Property ${idx + 1}`,
        value: `Value ${idx + 1}`
      })),
    }; */
    // setDetailedInfo(fetchedInfo);
    // setDetailedInfo(null);
    // -------------------



  };

  useEffect(() => {
    if (curindex !== -1) {
      setModalIndex(curindex);
      fetchFileInfo(curindex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curindex]);



  useEffect(() => {
    if (detailedInfo&&detailedInfo.video_link) {
      setCurrentFileVideoUrl(decodeURIComponent(detailedInfo.video_link.replace(/\\\//g, "/")))
    }else setCurrentFileVideoUrl(null)

    setVisibleDenseCaptions(isAreasVisible ? detailedInfo?.aiRaw.denseCaptionsResult : null);
    setVisiblePeople(isPeopleVisible ? detailedInfo?.aiRaw.peopleResult?.values : null);
    setVisibleObjects(isObjectsVisible ? detailedInfo?.aiRaw.objectsResult?.values : null);
    setVisibleReadResults(isTextsVisible ? detailedInfo?.aiRaw?.readResult?.blocks : null);
    setVisibleSmartCrop(isSmartCropVisible ? detailedInfo?.smartCropsResult : null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailedInfo]);

  const handleOpenLightbox = () => {
    setLightboxOpen(true);

    const lightboxFile = slides[modalIndex];
    if (!lightboxFile) return;
    const tempIndex = filteredSlidesForLightbox.findIndex(file => file.id === lightboxFile.id);

    if (tempIndex !== -1) setLightboxIndex(tempIndex);


  };

  const handleCloseLightbox = () => {
    // console.log('closing with inbdex ',lightboxIndex)
    setLightboxOpen(false);
    const lightboxFile = filteredSlidesForLightbox[lightboxIndex];
    // console.log('aktualny lightbox file ',lightboxFile)

    if (!lightboxFile) return; // Ochrana proti chybám

    // Nájdeme index tohto súboru v pôvodnom `slides`
    const originalIndex = slides.findIndex(file => file.id === lightboxFile.id);
    // console.log('index v slides ',originalIndex)

    if (originalIndex !== -1) {
      setModalIndex(originalIndex);
      fetchFileInfo(originalIndex);
    }
  };

  const handlePrevious = useCallback(() => {
    // console.log("modalIndex:",modalIndex)
    const newIndex = (modalIndex - 1 + slides.length) % slides.length;
    // console.log("newIndex:",newIndex)
    setModalIndex(newIndex);
    fetchFileInfo(newIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalIndex, slides.length]);

  const handleNext = useCallback(() => {
    // console.log("modalIndex:",modalIndex)
    const newIndex = (modalIndex + 1) % slides.length;
    // console.log("newIndex:",newIndex)
    setModalIndex(newIndex);
    fetchFileInfo(newIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalIndex, slides.length]);


  const handleKeyDown = (event) => {
    if (editFilenameOpen) return;
    if (!lightboxOpen) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        handlePrevious();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        handleNext();
      }
    }
  };


  const [editFilenameOpen, setEditFilenameOpen] = useState(false);
  const [editedFilename, setEditedFilename] = useState(detailedInfo?.filename || "");

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handlePrevious, handleNext, lightboxOpen]);

  useEffect(() => {
    if(editFilenameOpen)window.removeEventListener('keydown', handleKeyDown);else
    window.addEventListener('keydown', handleKeyDown);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editFilenameOpen]);

  const handleCloseModal = () => {
    setLightboxOpen(false);
    setIndex(-1);
  };


  const changeFileName = async (fileId) => {
    const jwt = localStorage.getItem('axjwt');
    if (jwt) {
      try {
        const postData = new FormData();
        postData.append('action', 'change_pixme_filename');
        postData.append('new_filename', editedFilename);
        postData.append('file_id', fileId);
        postData.append('in_dep', "current"); // current or all
        postData.append('in_folder', "all"); // all, or string of digits, delimited by comma

        const response = await axios.post('https://api.administrix.pro/v1/post/', postData, {
          headers: {'Authorization': `Bearer ${jwt}`}
        });

        const responseData = response.data;
        const {meta} = responseData;

        if (meta?.jwt) localStorage.setItem('axjwt', meta.jwt);

        if (responseData.data.success) {
          enqueueSnackbar(t('fileinfo.filenameChangeSucc'), {variant: 'success', autoHideDuration: 6000});

        } else {
          enqueueSnackbar(t('fldcard.filenameChangeFailed'), {variant: 'error', autoHideDuration: 6000});

        }
      } catch (error) {
        if (error.response) {
          console.error("Server error:", error.response);
          enqueueSnackbar(`Error: ${error.response.data.error.title || 'Unknown'}`, {variant: 'error', autoHideDuration: 6000});

        } else {
          console.error("Request error:", error.message);
          enqueueSnackbar("Network or API error.", {variant: 'error', autoHideDuration: 6000});

        }
      }
    }
  };

  const currentFile = slides[modalIndex];
  const filteredSlidesForLightbox = slides.filter(file => file.showInLightBox !== false);

  // console.log(currentFile)
  // console.log("filteredSlidesForLightbox",filteredSlidesForLightbox)

  const fileExifInfoFields = [
    { key: "aperture", label: t("fileinfo.aperture") },
    { key: "camera_manufacturer", label: t("fileinfo.camera_manufacturer") },
    { key: "camera_model", label: t("fileinfo.camera_model") },
    // { key: "exif_id", label: t("fileinfo.exif_id") },
    { key: "exif_version", label: t("fileinfo.exif_version") },
    { key: "exposure_time", label: t("fileinfo.exposure_time") },
    // { key: "filetype", label: t("fileinfo.filetype") },
    { key: "focal_length", label: t("fileinfo.focal_length") },
    { key: "gps_altitude", label: t("fileinfo.gps_altitude") },
    { key: "gps_altitude_ref", label: t("fileinfo.gps_altitude_ref") },
    { key: "gps_lat", label: t("fileinfo.gps_lat") },
    { key: "gps_lat_ref", label: t("fileinfo.gps_lat_ref") },
    { key: "gps_long", label: t("fileinfo.gps_long") },
    { key: "gps_long_ref", label: t("fileinfo.gps_long_ref") },
    { key: "hasFaces", label: t("fileinfo.hasFaces") },
    { key: "orientation", label: t("fileinfo.orientation") },
  ];
  const isMeaningful = (value) => {
    if (value === undefined || value === null) return false;

    if (typeof value === "string") {
      const trimmed = value.trim();
      return trimmed !== "" && trimmed !== "0" && trimmed !== "0.00000000";
    }

    if (typeof value === "number") {
      return value !== 0;
    }

    return true;
  };

  const visibleFields = fileExifInfoFields.filter(({ key }) => isMeaningful(detailedInfo?.[key]));
  const formatFilesize = (bytes) => {
    const size = Number(bytes);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(size) || size === 0) return null;
    const units = ["B", "kB", "MB", "GB"];
    const index = Math.floor(Math.log(size) / Math.log(1024));
    const formatted = (size / 1024**index).toFixed(1);
    return `${formatted} ${units[index]}`;
  };
  const getPrintableSize = (resolutionStr) => {
    if (!resolutionStr || !resolutionStr.includes("x")) return null;
    const [widthPx, heightPx] = resolutionStr.split("x").map(Number);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(widthPx) || isNaN(heightPx)) return null;

    const dpiValues = [300, 200];
    const sizes = dpiValues.map(dpi => {
      const widthCm = Math.round((widthPx / dpi) * 2.54);
      const heightCm = Math.round((heightPx / dpi) * 2.54);
      return `${widthCm}×${heightCm} cm (${dpi} DPI)`;
    });

    return sizes.join(" or ");
  };



  const resolutionMap = [
    // { key: "thumb", label: t("fileinfo.res_thumb") || "Thumbnail" },
     { key: "preview", label: t("fileinfo.res_preview") || "Preview" },
    { key: "1318", label: t("fileinfo.res_1318") || "13×18" },
    { key: "a4", label: t("fileinfo.res_a4") || "A4" },
    { key: "full", label: t("fileinfo.res_full") || t("fileinfo.original") || "Original" },
  ];

  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const downloadOpen = Boolean(downloadAnchorEl);

  const handleOpenDownload = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };
  const handleCloseDownload = () => {
    setDownloadAnchorEl(null);
  };
  const handleDownload = (type) => {
    console.log("Download type:", type);
    handleCloseDownload();
  };

// Vypočítaj text pre full resolution
  const fullResolution = detailedInfo?.res_full || "";

  const downloadFullResText = (() => {
    const resolution = fullResolution;
    const filesize = detailedInfo?.filesize_full;
    const printableSize = getPrintableSize(resolution);
    if (!resolution || !filesize || filesize === "0") return "";
    return `${resolution} (${t("fileinfo.res_full")}${printableSize ? `, ${t("fileinfo.suitableForPrint")} ${printableSize}` : ""}), ${formatFilesize(filesize)}`;
  })();

// render boxes and texts setup
// Stavy zobrazovania (lokálne)
  const [isDetectionsVisible, setIsDetectionsVisible] = useState(false);
  const [isAreasVisible, setIsAreasVisible] = useState(false);
  const [isPeopleVisible, setIsPeopleVisible] = useState(false);
  const [isObjectsVisible, setIsObjectsVisible] = useState(false);
  const [isTextsVisible, setIsTextsVisible] = useState(false);
  const [isSmartCropVisible, setIsSmartCropVisible] = useState(false);

// Aktívne dáta
  const [visibleDenseCaptions, setVisibleDenseCaptions] = useState(null);
  const [visiblePeople, setVisiblePeople] = useState(null);
  const [visibleObjects, setVisibleObjects] = useState(null);
  const [visibleReadResults, setVisibleReadResults] = useState(null);
  const [visibleSmartCrop, setVisibleSmartCrop] = useState(null);

  useEffect(() => {
    if (isDetectionsVisible) {

      fetchFileInfo(curindex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDetectionsVisible]);

// Handlery prepínania checkboxov
  const toggleDetectionsVisibility = (e) => {
    setIsDetectionsVisible(e.target.checked);
    if(!e.target.checked){
      setIsAreasVisible(false);
      setIsPeopleVisible(false);
      setIsObjectsVisible(false);
      setIsTextsVisible(false);
      setIsSmartCropVisible(false);
      setVisibleDenseCaptions(null);
      setVisiblePeople(null);
      setVisibleObjects(null);
      setVisibleReadResults(null);
      setVisibleSmartCrop(null);
    }

  }

  const toggleAreasVisibility = (e) => {
    const checked = e.target.checked;
    setIsAreasVisible(checked);
    setVisibleDenseCaptions(checked ? detailedInfo?.aiRaw?.denseCaptionsResult : null);
  };

  const togglePeopleVisibility = (e) => {
    const checked = e.target.checked;
    setIsPeopleVisible(checked);
    setVisiblePeople(checked ? detailedInfo?.aiRaw?.peopleResult?.values : null);
  };

  const toggleObjectsVisibility = (e) => {
    const checked = e.target.checked;
    setIsObjectsVisible(checked);
    setVisibleObjects(checked ? detailedInfo?.aiRaw?.objectsResult?.values : null);
  };

  const toggleTextsVisibility = (e) => {
    const checked = e.target.checked;
    setIsTextsVisible(checked);
    setVisibleReadResults(checked ? detailedInfo?.aiRaw?.readResult?.blocks : null);
  };

  const toggleSmartCropVisibility = (e) => {
    const checked = e.target.checked;
    setIsSmartCropVisible(checked);
    setVisibleSmartCrop(checked ? detailedInfo?.smartCropsResult : null);
  };


  const showAiPanel = ({
                         // eslint-disable-next-line no-shadow
                         showDetections,
                         showAreas,
                         showPeople,
                         showObjects,
                         showTexts,
                         showSmartCrop,
                         handleToggleDetections,
                         handleToggleAreas,
                         handleTogglePeople,
                         handleToggleObjects,
                         handleToggleTexts,
                         handleToggleSmartCrop,
                         denseCaptions,
                         peopleResult,
                         objectsResult,
                         readResult,
                         smartCrops,
                       }) => {


    const texts = readResult?.flatMap(block =>
      block.lines?.map(line => line.text?.trim()).filter(Boolean)
    ) || [];

    return (

    <Paper elevation={3} sx={{p: 2, mt: 2}}>
      <FormGroup>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showDetections}
              onChange={handleToggleDetections}
            />
          }
          label={t('fileinfo.showAiDetections')}
        />
        </Box>
        {showDetections && (
          (detailedInfo?.aiRaw?.denseCaptionsResult &&
              detailedInfo?.aiRaw?.peopleResult?.values &&
              detailedInfo?.aiRaw?.objectsResult?.values &&
              detailedInfo?.aiRaw?.readResult?.blocks &&
              detailedInfo?.smartCropsResult)?
          <Box sx={{pl: 3,display: 'flex', justifyContent: 'center'}}>
            {detailedInfo?.aiRaw?.denseCaptionsResult && <FormControlLabel
              control={
                <Checkbox
                  checked={showAreas}
                  onChange={handleToggleAreas}
                />
              }
              label={t('fileinfo.showAreas')}
            />}
            {detailedInfo?.aiRaw?.peopleResult?.values && <FormControlLabel
              control={
                <Checkbox
                  checked={showPeople}
                  onChange={handleTogglePeople}
                />
              }
              label={t('fileinfo.showPeople')}
            />}
            {detailedInfo?.aiRaw?.objectsResult?.values && <FormControlLabel
              control={
                <Checkbox
                  checked={showObjects}
                  onChange={handleToggleObjects}
                />
              }
              label={t('fileinfo.showObjects')}
            />}
            {detailedInfo?.aiRaw?.readResult?.blocks && <FormControlLabel
              control={
                <Checkbox
                  checked={showTexts}
                  onChange={handleToggleTexts}
                />
              }
              label={t('fileinfo.showTexts')}
            />}
            {detailedInfo?.smartCropsResult && <FormControlLabel
              control={
                <Checkbox
                  checked={showSmartCrop}
                  onChange={handleToggleSmartCrop}
                />
              }
              label={t('fileinfo.showSmartCrop')}
            />}
          </Box>:'No detection found'
        )}
      </FormGroup>

      {showDetections && texts.length > 0 && (
        <>
          <Divider sx={{my: 2}}/>
          <Typography variant="subtitle1" gutterBottom>
            {t('fileinfo.recognizedTexts')}
          </Typography>
          <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
            {texts.map((text, index) => (
              <Chip
                key={`text-${index}`}
                label={text}
                variant="outlined"
                deleteIcon={
                  <Tooltip title={t('fileinfo.copyToClipboard')}>
                    <ContentCopyIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        navigator.clipboard.writeText(text).catch((err) =>
                          console.error('Copy failed', err)
                        );
                      }}
                      sx={{cursor: 'pointer'}}
                    />
                  </Tooltip>
                }
                onDelete={() => {
                  navigator.clipboard.writeText(text).catch((err) =>
                    console.error('Copy failed', err)
                  );
                }}
              />
            ))}
          </Box>
        </>
      )}
    </Paper>

    );
  };


  const isJpgOrJpeg = typeof detailedInfo?.filename === 'string' &&
    /\.(jpe?g)$/i.test(detailedInfo.filename);
  return (
    <Modal
      open={curindex >= 0}
      onClose={handleCloseModal}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"

    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 3,
        maxWidth: 1300,
        width: '90%',
        maxHeight: '90vh', // Obmedzenie výšky na 90% viewportu
        overflowY: 'auto', // Umožní skrolovanie obsahu
        p: 4,
      }}>
        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}>
          <Typography id="modal-title" variant="h6" style={{textAlign: "center"}}>
            {t("fileinfo.detailTitle")}
          </Typography>
          <IconButton onClick={handleCloseModal}>
            <CloseIcon/>
          </IconButton>
        </Box>

        <Box display="flex" alignItems="center">
          <IconButton onClick={handlePrevious}>
            <ArrowBack/>
          </IconButton>

          <Box flexGrow={1} mx={2} sx={{position: 'relative', transition: 'opacity 0.5s', opacity: 1}}>
            {currentFileVideoUrl && (
              <ReactPlayer
                playing
                url={currentFileVideoUrl}
                width="100%"
                // light
                controls
                config={{
                  file: {
                    attributes: {
                      crossOrigin: 'anonymous'
                    }
                  }
                }}
              />
            )
            }
            {currentFile?.type !== "video" && (
              <>
                {console.log(detailedInfo)}

                {detailedInfo && (
                  <ImageWithAnnotations
                    src={currentFile?.src}
                    alt={currentFile?.alt}
                    showInLightBox={currentFile?.showInLightBox}
                    onClick={handleOpenLightbox}
                    denseCaptions={visibleDenseCaptions}
                    peopleResult={visiblePeople}
                    objectsResult={visibleObjects}
                    readResult={visibleReadResults}
                    smartCrops={visibleSmartCrop}
                    imageSize={detailedInfo?.res_preview}
                  />
                )}



                {/*
                <Image
                  src={currentFile?.src || ''} // Ak nie je src, použije prázdny reťazec
                  alt={currentFile?.alt || 'No image available'} // Bezpečný alt text
                  style={{cursor: 'pointer', width: '100%', borderRadius: '5px'}}
                  onClick={currentFile?.showInLightBox ? handleOpenLightbox : undefined}
                />
                */}

                {currentFile?.showInLightBox && (
                  <IconButton sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'rgba(255, 255, 255, 0.8)'
                  }} onClick={handleOpenLightbox}>
                    <ZoomIn/>
                  </IconButton>)}
              </>)}


          </Box>



          <IconButton onClick={handleNext}>
            <ArrowForward/>
          </IconButton>
        </Box>

        {isJpgOrJpeg&&showAiPanel({
          showDetections: isDetectionsVisible,
          showAreas: isAreasVisible,
          showPeople: isPeopleVisible,
          showObjects: isObjectsVisible,
          showTexts: isTextsVisible,
          showSmartCrop: isSmartCropVisible,
          handleToggleDetections: toggleDetectionsVisibility,
          handleToggleAreas: toggleAreasVisibility,
          handleTogglePeople: togglePeopleVisibility,
          handleToggleObjects: toggleObjectsVisibility,
          handleToggleTexts: toggleTextsVisibility,
          handleToggleSmartCrop: toggleSmartCropVisibility,
          denseCaptions: visibleDenseCaptions,
          peopleResult: visiblePeople,
          objectsResult: visibleObjects,
          readResult: visibleReadResults,
          smartCrops: visibleSmartCrop,
        })
        }

        {showDetailedInfo&&detailedInfo && (<>
        <Box display="flex" justifyContent="center" alignItems="center" mt={2} mb={2}>
          <Typography variant="h6" sx={{ mr: 1 }}>
            {detailedInfo?.original_filename}
          </Typography>
          <IconButton
            aria-label={t("fileinfo.edit")}
            size="small"
            onClick={() => {
              setEditedFilename(detailedInfo.original_filename);
              setEditFilenameOpen(true);
            }}
            sx={{ color: "grey.600" }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Box>

        <Dialog open={editFilenameOpen} onClose={() => setEditFilenameOpen(false)} maxWidth="xs" fullWidth>
          <DialogTitle>{t("fileinfo.edit_filename_title")}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              fullWidth
              value={editedFilename}
              label={t("fileinfo.edit_filename_title")} // Ak nechceš použiť i18n
              onChange={(e) => setEditedFilename(e.target.value)}

            />
          </DialogContent>
          <DialogActions>

            <Button
              onClick={() => {
                setDetailedInfo(prev => ({
                  ...prev,
                  filename: editedFilename,
                }));
                changeFileName(detailedInfo.fileid);
                setEditFilenameOpen(false);
              }}
              variant="contained"
            >
              {t("save")}
            </Button>
            <Button onClick={() => setEditFilenameOpen(false)}>
              {t("cancel")}
            </Button>
          </DialogActions>
        </Dialog>
        <Typography align="center" color="text.secondary">{downloadFullResText}</Typography>
        </>)}


        {showDetailedInfo&&detailedInfo && (
          <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} mt={2} mb={2}>
            <Card sx={{padding: 2, boxShadow: 3, width: "100%"}}>
              <CardContent>
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>

                  <IconButton onClick={handleOpenDownload}>
                    <DownloadIcon/>
                  </IconButton>


                  <Popover
                    open={downloadOpen}
                    anchorEl={downloadAnchorEl}
                    onClose={handleCloseDownload}
                    anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                    transformOrigin={{vertical: "top", horizontal: "center"}}
                  >
                    {resolutionMap.map(({key, label}) => {
                      const resolution = detailedInfo?.[`res_${key}`];
                      const filesize = detailedInfo?.[`filesize_${key}`];

                      if (!resolution || resolution === "0" || !filesize || filesize === "0") return null;
                      if (key !== "full" && resolution === fullResolution) return null;

                      const printableSize = key === "full" ? getPrintableSize(resolution) : null;
                      const text = `${resolution} (${label}${printableSize ? `, ${t("fileinfo.suitableForPrint")} ${printableSize}` : ""}), ${formatFilesize(filesize)}`;

                      const tooltip =
                        // eslint-disable-next-line no-nested-ternary
                        key === "1318"
                          ? t("fileinfo.download_1318")
                          // eslint-disable-next-line no-nested-ternary
                          : key === "a4"
                            ? t("fileinfo.download_a4")
                            : key === "preview"
                              ? t("fileinfo.download_preview")
                              : t("fileinfo.download_full");

                      return (
                        <MenuItem
                          key={key}
                          onClick={() => {
                            handleDownload(key);
                            handleCloseDownload();
                          }}
                        >
                          <Tooltip title={tooltip}>
                            <DownloadIcon fontSize="small" style={{marginRight: 8}}/>
                          </Tooltip>
                          <Tooltip title={tooltip}>
                            <Typography variant="body2" style={{textAlign: "center"}}>{text}</Typography>
                          </Tooltip>
                        </MenuItem>
                      );
                    })}
                  </Popover>


                  <IconButton aria-label={t("fileinfo.share")}>
                    <ShareIcon/>
                  </IconButton>
                  <IconButton aria-label={t("fileinfo.delete")}>
                    <DeleteIcon/>
                  </IconButton>

                  {detailedInfo.pdf&&<>
                  <Button onClick={() => setOpenPdfViewer(true)}>Zobraziť PDF</Button>
                                    <PdfViewerModal open={openPdfViewer} onClose={() => setOpenPdfViewer(false)} pdfUrl="https://krupina.sk/web_files/2025/5/13443.pdf" />

                  </>
                  }
                </Stack>

                <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} mt={2}>
                  <Checkbox
                    checked={selectedFiles_exists(currentImageId)}
                    onChange={handleSelect}
                  />
                  <Typography>{t("fileinfo.checked")}</Typography>
                </Stack>
              </CardContent>
            </Card>
          </Stack>)}

        {showDetailedInfo&&detailedInfo && (
          <Card>
            <CardContent>
              {/* Basic Information */}
              <Box mb={2}>
                <List dense disablePadding>
                  {resolutionMap.map(({key, label}) => {
                    const resolution = detailedInfo?.[`res_${key}`];
                    const filesize = detailedInfo?.[`filesize_${key}`];

                    // Skip if resolution is missing or zero
                    if (!resolution || resolution === "0" || !filesize || filesize === "0") return null;

                    // Skip duplicate resolution compared to full (original)
                    if (key !== "full" && resolution === fullResolution) return null;

                    // Add printable size info if it's the original
                    const printableSize = key === "full" ? getPrintableSize(resolution) : null;

                    return (
                      <ListItem key={key} disableGutters disablePadding>
                        <Typography variant="body2" sx={{display: "inline", mr: 1}}>
                          {resolution} ({label}
                          {printableSize ? `, ${t('fileinfo.suitableForPrint')} ${printableSize}` : ""}
                          ), {formatFilesize(filesize)}
                        </Typography>

                        <Tooltip
                          title={
                            // eslint-disable-next-line no-nested-ternary
                            key === "1318"
                              ? t("fileinfo.download_1318")
                              // eslint-disable-next-line no-nested-ternary
                              : key === "a4"
                                ? t("fileinfo.download_a4")
                                : key === "preview"
                                  ? t("fileinfo.download_preview")
                                  : t("fileinfo.download_full")
                          }
                        >
                          <IconButton onClick={() => handleDownload(key)} size="small">
                            <DownloadIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
              <Box mb={2}>
                {/* console.log('ax_store:',axStore) */}
                { console.log('showInLocaleLanguage:',showInLocaleLanguage) }
                {detailedInfo.aiCaptionLocal && <Typography variant="h6">{t("fileinfo.caption")}: {showInLocaleLanguage?detailedInfo.aiCaptionLocal:detailedInfo.aiCaptionEn}</Typography>}
                {detailedInfo.pdf?.caption_locale && <Typography variant="body1">{t("fileinfo.caption")}: {showInLocaleLanguage?detailedInfo.pdf?.caption_locale:detailedInfo.pdf?.caption}</Typography>}
                {detailedInfo.pdf?.anotation_locale && <Typography variant="h6"> {showInLocaleLanguage?detailedInfo.pdf?.anotation_locale:detailedInfo.pdf?.anotation}</Typography>}


                <Typography>{t("fileinfo.resolution")}: {fileInfo.resolution}</Typography>
                <Typography>{t("fileinfo.dateTaken")}: {fileInfo.dateTaken}</Typography>
                <Typography>{t("fileinfo.dateUploaded")}: {fileInfo.dateUploaded}</Typography>
                <Typography>{t("fileinfo.author")}: {fileInfo.author}</Typography>
              </Box>

              <Divider/>

              {/* License and Description */}
              <Box mb={2}>
                <Typography>{t("fileinfo.license")}: {fileInfo.license}</Typography>
                <Typography>{t("fileinfo.systemAlert")}: {fileInfo.systemAlert}</Typography>
                <Typography>{t("fileinfo.userInfo")}: {fileInfo.userInfo}</Typography>
                <Typography>{t("fileinfo.licenseValidity")}: {fileInfo.licenseValidity}</Typography>
                <Typography>{t("fileinfo.description")}: {fileInfo.description}</Typography>
              </Box>
              <Divider/>

              {/* Accordion Section */}
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                  <Typography><strong>{t("fileinfo.systemInfo")}</strong></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2"><strong>{t("fileinfo.system_filename")}:</strong> {detailedInfo?.filename}</Typography>
                  <Typography variant="body2"><strong>{t("fileinfo.system_id")}:</strong> {detailedInfo.file_id}</Typography>
                </AccordionDetails>
              </Accordion>

              {visibleFields.length > 0 && (
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography><strong>{t("fileinfo.exifInfo")}</strong></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {visibleFields.map(({key, label}) => (
                      <Typography key={key} variant="body2">
                        <strong>{label}:</strong> {detailedInfo[key]}
                      </Typography>
                    ))}
                  </AccordionDetails>
                </Accordion>
              )}

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                  <Typography><strong>{t("fileinfo.userTags")}</strong></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {fileInfo.userTags.map((tag, index) => (
                    <Chip key={index} label={tag} sx={{margin: 0.5}}/>
                  ))}
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                  <Typography><strong>{t("fileinfo.aiTagsEnglish")}</strong></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {fileInfo.aiTagsEnglish.map((tag, index) => (
                    <Chip key={index} label={tag} sx={{margin: 0.5}}/>
                  ))}
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                  <Typography><strong>{t("fileinfo.aiTagsLocal")}</strong></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {fileInfo.aiTagsLocal.map((tag, index) => (
                    <Chip key={index} label={tag} sx={{margin: 0.5}}/>
                  ))}
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                  <Typography><strong>{t("fileinfo.directories")}</strong></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {fileInfo.directories.map((dir, index) => (
                      <Box key={index}>{dir}</Box>
                    ))}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                  <Typography>{t("fileinfo.downloadLog")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {fileInfo.downloadLog.map((log, index) => (
                      <Box key={index}>{log}</Box>
                    ))}
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                  <Typography>{t("fileinfo.processingLog")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>{fileInfo.processingLog}</Typography>
                </AccordionDetails>
              </Accordion>
            </CardContent>
          </Card>
        )}


        <Lightbox

          slides={filteredSlidesForLightbox}


          open={lightboxOpen}
          index={lightboxIndex}
          close={handleCloseLightbox}
          on={{
            view: ({index}) => {
              setLightboxIndex(index);
            },
          }}
          controller={{
            closeOnBackdropClick: true,
          }}
          plugins={[Fullscreen, Slideshow]} // Pridanie pluginov
          slideshow={{autoplay: false, delay: 3000}} // Nastavenie slideshow
          render={(slide) => slide.showInLightBox ? <img src={slide.src} alt={slide.alt}/> : null}
        />

      </Box>
    </Modal>
  );
};

ModalLightboxForFilePreview.propTypes = {
  slides: PropTypes.array,
  curindex: PropTypes.number,
  setIndex: PropTypes.func
};

export default ModalLightboxForFilePreview;
